export default {
  mainVenue: [
    {
      time: '09:35-10:00',
      affair: {
        type: '主题演讲',
        title: '第二个五年·蓄势向上',
        speakers: [
          {
            name: '韩牧',
            title: '懒熊体育创始人&CEO',
          },
        ],
      },
    },
    {
      time: '10:00-10:40',
      affair: {
        type: '圆桌论坛',
        title: '体育·新趋势：后浪已至，谁占潮头',
        speakers: [
          {
            title: '',
            name: '',
          },
          {
            title: '',
            name: '',
          },
          {
            title: '',
            name: '',
          },
          {
            title: '',
            name: '',
          },
          {
            title: '',
            name: '',
          },
        ],
      },
    },
    {
      time: '10:40-11:20',
      affair: {
        type: '圆桌论坛',
        title: '体育·新内容：理性与感性',
        speakers: [],
      },
    },
    {
      time: '11:20-11:35',
      affair: {
        type: '主题演讲',
        title: '“新国货”蝶变',
        speakers: [
          {
            name: '李玲',
            title: '安踏集团副总裁',
          },
        ],
      },
    },
    {
      time: '13:30-14:00',
      affair: {
        type: '互动对话',
        title: '体育·新消费：双循环下再升级',
        speakers: [],
      },
    },
    {
      time: '14:00-14:40',
      affair: {
        type: '圆桌论坛',
        title: '体育·新营销：24个月 VS 长期主义',
        speakers: [],
      },
    },
    {
      time: '14:40-15:20',
      affair: {
      type: '圆桌论坛',
      title: '体育·新城市：更新中的体育角色',
      speakers: [],
      },
    },
    {
      time: '15:40-16:20',
      affair: {
        type: '圆桌论坛',
        title: '体育·新参与：迎接反弹',
        speakers: [],
      },
    },
    {
      time: '16:20-17:00',
      affair: {
        type: '圆桌论坛',
        title: '体育·新智造：重塑运动',
        speakers: [],
      },
    },
    {
      time: '17:00-17:50',
      affair: {
        type: '圆桌论坛',
        title: '体育·新教育：体教融合的一代',
        speakers: [],
      },
    },
    {
      time: '17:50-18:30',
      affair: {
        type: '圆桌论坛',
        title: '体育·新跨界：等待爆款',
        speakers: [],
      },
    },

  ],
  parallelVenue: [
    // {
    //   time: '14:30-14:40',
    //   affair: {
    //     type: '开场',
    //     title: '',
    //     speakers: [],
    //   },
    // },
    {
      time: '14:40-15:00',
      affair: {
        type: '体育产业年度领袖人物',
        title: '',
        speakers: [],
      },
    },
    {
      time: '15:00-15:40',
      affair: {
        type: '体育产业年度营销奖',
        title: '',
        speakers: [
          {
            name: '',
            title: '',
          },
          {
            name: '',
            title: '',
          },
          {
            name: '',
            title: '',
          },
        ],
      },
    },
    {
      time: '15:40-16:20',
      affair: {
        type: '体育产业年度创新奖',
        title: '',
        speakers: [
          {
            name: '',
            title: '',
          },
          {
            name: '',
            title: '',
          },
          {
            name: '',
            title: '',
          },
        ],
      },
    },
  ],
  awards: [
    {
      time: '',
      affair: {
        type: '中国体育产业年度领袖人物',
        title: '',
        speakers: [
          {
            name: ``,
            title: '',
          },
          {
            name: '',
            title: '',
          },
          {
            name: '',
            title: '',
          },
        ],
      },
    },
    {
      time: '',
      affair: {
        type: '中国体育产业年度营销奖',
        title: '',
        speakers: [
          {
            name: ``,
            title: '',
          },
          {
            name: '',
            title: '',
          },
          {
            name: '',
            title: '',
          },
        ],
      },
    },
    {
      time: '',
      affair: {
        type: '中国体育产业年度创新奖',
        title: '',
        speakers: [
          {
            name: ``,
            title: '',
          },
          {
            name: '',
            title: '',
          },
          {
            name: '',
            title: '',
          },
        ],
      },
    },
  ],
  workshop: [
    {
      time: '',
      affair: {
        type: '体育创新与城市发展',
        title: '',
        speakers: [
          {
            name: ``,
            title: '',
          },
          {
            name: '',
            title: '',
          },
          {
            name: '',
            title: '',
          },
        ],
      },
    },
    {
      time: '',
      affair: {
        type: '体育营销的技术变革',
        title: '',
        speakers: [
          {
            name: ``,
            title: '',
          },
          {
            name: '',
            title: '',
          },
          {
            name: '',
            title: '',
          },
        ],
      },
    },
    {
      time: '',
      affair: {
        type: '体育科技的颠覆应用',
        title: '',
        speakers: [
          {
            name: ``,
            title: '',
          },
          {
            name: '',
            title: '',
          },
          {
            name: '',
            title: '',
          },
        ],
      },
    },
  ],
};
